import { render, staticRenderFns } from "./QrScanBoard.vue?vue&type=template&id=4ec764df&scoped=true"
import script from "./QrScanBoard.vue?vue&type=script&lang=js"
export * from "./QrScanBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec764df",
  null
  
)

export default component.exports